import { injectShoutcastStreams } from '../../../transforms/streams/injectShoutcastStreams';
import getMediaFormat from '../../../utils/getMediaFormat';
import { transformMislabelledHlsStreams } from '../transformMislabelledHlsStreams';
export function transformUnwrappedStreams(streams, metadata) {
    return streams
        .map(({ url, reliability, playlistType, mediaType, streamId }) => ({
        ...metadata,
        url,
        reliability,
        format: getMediaFormat(playlistType, mediaType),
        id: `e${streamId}`,
    }))
        .map(transformMislabelledHlsStreams)
        .reduce(injectShoutcastStreams, []);
}
